import { io } from 'socket.io-client';
import { NATIVE_SERVER_URL } from './config';

const isNative = !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());

// In the native app (Capacitor), assets are bundled — connect to the deployed server.
// In production web (Docker), the server serves the client — connect to same origin.
// In development, CRA runs on :3000 and the server on :4000.
const SERVER_URL = isNative
  ? NATIVE_SERVER_URL
  : process.env.NODE_ENV === 'production'
    ? window.location.origin
    : 'http://localhost:4000';

// Session persistence:
//  - production / native: localStorage, so the session survives the OS killing
//    the app process (Android backgrounding) and full app restarts
//  - development: sessionStorage, so each browser tab is a distinct player
//    (keeps the two-tab local testing workflow working)
const storage =
  process.env.NODE_ENV === 'production' || isNative
    ? window.localStorage
    : window.sessionStorage;

let sessionId = storage.getItem('gamePortal_sessionId');
if (!sessionId) {
  sessionId = 'sid_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
  storage.setItem('gamePortal_sessionId', sessionId);
}

const socket = io(SERVER_URL, {
  autoConnect: false,
});

export { sessionId, storage };
export default socket;
